import { render, staticRenderFns } from "./LookupFormInput.vue?vue&type=template&id=8d0f2d40&scoped=true&"
import script from "./LookupFormInput.vue?vue&type=script&lang=ts&"
export * from "./LookupFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./LookupFormInput.vue?vue&type=style&index=0&id=8d0f2d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0f2d40",
  null
  
)

export default component.exports